export enum EnumApiTonghao {
  Moments = '/moment/api/moments/mix/bytopic',
  FollowsMoments = '/moment/api/moments/follows',
  RecommendCitys = '/moment/api/citys/recommend'
}
